import { DndContext } from "@dnd-kit/core";
import type { DragEndEvent, DragStartEvent } from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";

const DndSortableContext = ({
  dataSource,
  onDragStart,
  onDragEnd,
  children,
}: {
  dataSource: { id: string; [key: string]: any }[];
  onDragStart?: ({ active }: DragStartEvent) => void;
  onDragEnd: ({ active, over }: DragEndEvent) => void;
  children: JSX.Element;
}) => {
  return (
    <div>
      <DndContext modifiers={[restrictToVerticalAxis]} onDragStart={onDragStart} onDragEnd={onDragEnd}>
        <SortableContext
          // rowKey array
          items={dataSource?.map((i) => i.id)}
          strategy={verticalListSortingStrategy}
        >
          {children}
        </SortableContext>
      </DndContext>
    </div>
  );
};

export default DndSortableContext;
